
const accordItemButton = document.querySelectorAll('.s-accord-item__title')
if (accordItemButton){
  accordItemButton.forEach(button => {
    button.addEventListener('click', function () {

      const content = this.nextElementSibling
      const contentHeight = content.scrollHeight + "px"
      const chevron = this.getElementsByTagName('div')

      if (content.classList.contains('s-accord-item__content--show')) {
        this.nextElementSibling.style.maxHeight = "0px"
        this.nextElementSibling.classList.remove('s-accord-item__content--show')
        chevron[0].classList.remove('s-accord-item__title-icon__rotate')

      } else {
        this.nextElementSibling.style.maxHeight = contentHeight
        this.nextElementSibling.classList.add('s-accord-item__content--show')
        chevron[0].classList.add('s-accord-item__title-icon__rotate')
      }

    })
  });
}
